import type {
  StructuredSearchAggregations,
  StructuredSearchResult,
  StructuredSearchStatistics,
} from '@core/Areas/StructuredSearch/types'
import { get } from '@core/Services/ApiService'

export async function getStructuredSearchResults(
  /** @requires prefix `?` if not empty */
  queryParams: string
) {
  return get<{
    hitCount: number
    results: StructuredSearchResult[]
    statistics: StructuredSearchStatistics
    aggregations: StructuredSearchAggregations | null
  }>({ url: `/api/search/structured${queryParams}` })
}
